export const DEMANDAS = {
  INVESTIGACAO_INTERNA: "INVESTIGACAO_INTERNA",
  ACOMPANHAMENTO_PSICOLOGICO: "ACOMPANHAMENTO_PSICOLOGICO",
  AFASTAMENTO_TEMPORARIO: "AFASTAMENTO_TEMPORARIO",
} as const;

export const TIPOS_ASSEDIO = {
  MORAL: "MORAL",
  SEXUAL: "SEXUAL",
  AMBOS: "AMBOS",
} as const;
